import { InboxIndicationColorsService } from '@api'

export interface AddColorBody {
  price: number
  colorHex: string
  backgroundColorHex: string | null
}

async function addColor(creatorId: number | undefined, body: AddColorBody) {
  if (!creatorId) {
    throw new Error('Creator ID is required')
  }

  return InboxIndicationColorsService.apiAddColor({
    creatorId,
    requestBody: {
      price: body.price,
      colorHex: body.colorHex,
      backgroundColorHex: body.backgroundColorHex ?? undefined,
    },
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function editColor({ id, ...rest }: any) {
  return InboxIndicationColorsService.updateInboxIndicationColor({
    id,
    requestBody: rest,
  })
}

async function deleteColor(creatorId: number | undefined, id: number) {
  if (!creatorId) {
    throw new Error('Creator ID is required')
  }

  return InboxIndicationColorsService.apiDeleteColor({
    creatorId,
    id,
  })
}

export const inboxIndicationColorService = {
  addColor,
  editColor,
  deleteColor,
}
